export default function Quote() {
  return (
    <section data-stage="4" className="relative py-32 md:py-48 px-6 md:px-12 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-gold/[0.04] blur-3xl" />
      </div>

      <div className="relative max-w-4xl mx-auto text-center">
        <div data-reveal className="mb-10">
          <i className="ri-double-quotes-l text-5xl text-gold/40"></i>
        </div>
        <blockquote
          data-reveal
          data-delay="1"
          className="font-display font-light text-center"
        >
          <p className="text-2xl md:text-4xl italic text-ink mb-12">
            Dinge, die wir häufiger hören möchten.
          </p>
          <div className="space-y-8 text-3xl md:text-5xl lg:text-6xl leading-[1.2] text-sage">
            <p>„Wann könnten wir starten?“</p>
            <p>„Können Sie mehr Kapazität übernehmen?“</p>
            <p>„Das hätten wir schon viel früher machen sollen.“</p>
            <p>„Wer hat bei Ihnen eigentlich das Telefon angenommen? Das war großartig.“</p>
          </div>
        </blockquote>

      </div>
    </section>
  );
}